<template>
    <div>
        <v-row no-gutters>
            <v-col cols="12">
                <h1 class="headline font-weight-light mb-3">
                    Setting Health Check
                </h1>
            </v-col>
        </v-row>

        <v-row v-for="(row, index) in data_main" :key="index">
            <v-col cols="12" class="col-thx11">
                {{ row.topic_name }}
            </v-col>
            <v-col cols="12" v-for="(r, i) in row.detail" :key="i">
                <div>
                    <span class="fttt01"> {{ r.detail_name }}</span>
                    <v-btn
                        x-small
                        fab
                        class="ml-2"
                        color="amber"
                        @click="open_dialog('Add', r.detail_id, '')"
                    >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                </div>
                <v-simple-table class="table-inv mt-1">
                    <template v-slot:default>
                        <thead>
                            <tr class="col-tr-1">
                                <th class="text-center" rowspan="2">#</th>
                                <th class="text-center" rowspan="2">
                                    ดำเนินการตรวจเช็ค
                                </th>
                                <th class="text-center" rowspan="2">
                                    วันที่เริ่มใช้งาน
                                </th>
                                <th class="text-center" colspan="3">
                                    มาตรฐานที่กำหนด
                                </th>
                                <th class="text-center" rowspan="2">
                                    ความถี่
                                </th>
                            </tr>
                            <tr class="col-tr-1">
                                <th class="text-center col-thx00 col-thx01">
                                    Normal
                                </th>
                                <th class="text-center col-thx00 col-thx02">
                                    Warning
                                </th>
                                <th class="text-center col-thx00 col-thx03">
                                    Critical
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(rr, ii) in r.list" :key="ii">
                                <td class="text-center">{{ ii + 1 }}.</td>
                                <td>
                                    <v-btn
                                        small
                                        rounded
                                        @click="
                                            open_dialog(
                                                'Edit',
                                                row.detail_id,
                                                rr
                                            )
                                        "
                                    >
                                        {{ rr.list_name }}
                                    </v-btn>
                                </td>
                                <td class="text-center">{{ rr.start_date }}</td>
                                <td>{{ rr.lvl_normal }}</td>
                                <td>{{ rr.lvl_warning }}</td>
                                <td>{{ rr.lvl_critical }}</td>
                                <td>{{ rr.frequency }}</td>
                            </tr>
                            <br />
                        </tbody>
                    </template>
                </v-simple-table>
            </v-col>
        </v-row>

        <v-dialog v-model="dialog" persistent max-width="800px">
            <v-card>
                <v-card-title>
                    <span class="text-h5">{{
                        status_x + " Health Check"
                    }}</span>
                </v-card-title>
                <v-card-text>
                    <v-container>
                        <v-row>
                            <v-col class="mar-t-20" cols="12" md="6">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form.list_name"
                                    label="ดำเนินการตรวจเช็ค"
                                ></v-text-field>
                            </v-col>
                            <v-col class="mar-t-20" cols="12" md="6">
                                <v-dialog
                                    ref="dialog"
                                    v-model="modal"
                                    :return-value.sync="form.start_date"
                                    persistent
                                    width="290px"
                                >
                                    <template v-slot:activator="{ on }">
                                        <v-text-field
                                            v-model="form.start_date"
                                            label="วันที่เริ่มใช้งาน"
                                            prepend-icon=""
                                            readonly
                                            v-on="on"
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </template>
                                    <v-date-picker v-model="date" scrollable>
                                        <v-spacer></v-spacer>
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="modal = false"
                                            >Cancel</v-btn
                                        >
                                        <v-btn
                                            text
                                            color="primary"
                                            @click="$refs.dialog.save(date)"
                                            >OK</v-btn
                                        >
                                    </v-date-picker>
                                </v-dialog>
                            </v-col>
                            <v-col class="mar-t-20" cols="12" md="4">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form.lvl_normal"
                                    label="Normal"
                                ></v-text-field>
                            </v-col>
                            <v-col class="mar-t-20" cols="12" md="4">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form.lvl_warning"
                                    label="Warning"
                                ></v-text-field>
                            </v-col>
                            <v-col class="mar-t-20" cols="12" md="4">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form.lvl_critical"
                                    label="Critical"
                                ></v-text-field>
                            </v-col>
                            <v-col class="mar-t-20" cols="12" md="6">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="form.frequency"
                                    label="ความถี่"
                                ></v-text-field>
                            </v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions class="mar-t-30">
                    <v-btn color="blue darken-1" text @click="close_dialog()">
                        Close
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="save(status_x)" rounded>
                        <div class="ml-2 mr-2">
                            <v-icon small class="mr-1">mdi-content-save</v-icon>
                            Save
                        </div>
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialog_loading" hide-overlay persistent width="320">
            <v-card color="primary" dark>
                <v-card-text>
                    <span class="mt-1 white--text">Loading</span>
                    <v-progress-linear
                        indeterminate
                        color="white"
                        class="mb-0"
                    ></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-dialog>
    </div>
</template>
<script>
import axios from "axios"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
    },
    mounted() {
        this.get_data()
    },
    methods: {
        async get_data() {
            this.dialog_loading = true
            await axios
                .get(url + "health-check/main-data")
                .then((response) => {
                    this.data_main = response.data.topic
                    this.dialog_loading = false
                })
                .catch((error) => {
                    console.log(error)
                })
        },
        open_dialog(st, id1, data) {
            this.form.detail_id = id1
            this.status_x = st
            if (st == "Edit") {
                this.form = {
                    list_id: data.list_id,
                    list_name: data.list_name,
                    start_date: data.start_date,
                    lvl_normal: data.lvl_normal,
                    lvl_warning: data.lvl_warning,
                    lvl_critical: data.lvl_critical,
                    frequency: data.frequency,
                }
            }
            this.dialog = true
        },
        close_dialog() {
            this.status_x = null
            this.form = {
                detail_id: "",
                list_id: "",
                list_name: "",
                start_date: "",
                lvl_normal: "",
                lvl_warning: "",
                lvl_critical: "",
                frequency: "",
                status: "Active",
            }
            this.dialog = false
        },
        async save(st) {
            if (st == "Edit") {
                this.dialog_loading = true
                await axios
                    .post(
                        url + "health-check/list/edit/" + this.form.list_id,
                        this.form,
                        this.tk
                    )
                    .then((response) => {
                        this.data_main = response.data.topic
                        this.dialog_loading = false
                        this.close_dialog()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            } else {
                this.dialog_loading = true
                await axios
                    .post(url + "health-check/list/new", this.form, this.tk)
                    .then((response) => {
                        this.data_main = response.data.topic
                        this.dialog_loading = false
                        this.close_dialog()
                    })
                    .catch((error) => {
                        console.log(error)
                    })
            }
        },
    },
    data() {
        return {
            tk: null,
            dialog: false,
            dialog_loading: false,
            data_main: [],
            status_x: null,
            modal: false,
            date: "",
            form: {
                detail_id: "",
                list_id: "",
                list_name: "",
                start_date: "",
                lvl_normal: "",
                lvl_warning: "",
                lvl_critical: "",
                frequency: "",
                status: "Active",
            },
        }
    },
}
</script>
<style scoped>
.col-thx11 {
    background-color: #03426a;
    color: #ffff;
    font-weight: bold;
}
.col-thx01 {
    background-color: #44cf49;
}
.col-thx02 {
    background-color: #d6d600;
}
.col-thx03 {
    background-color: #de0d0d;
}
.col-thx00 > th {
    color: #fff !important;
}
.fttt01 {
    color: #1d3351;
    font-weight: bold;
    font-size: 16px;
}
</style>
